import { Format } from "app/app.constants";

export const formatDate = (date, format = Format.time) =>
  date ? date.format(format) : "";
